const ID = 'alert';

export default ID;
